// extracted by extract-css-chunks-webpack-plugin
module.exports = {"qualificationsError":"qualification__qualificationsError--jGmDM"};